import { render, staticRenderFns } from "./detailsVant.vue?vue&type=template&id=1a1dcefc&scoped=true&"
import script from "./detailsVant.vue?vue&type=script&lang=js&"
export * from "./detailsVant.vue?vue&type=script&lang=js&"
import style0 from "./detailsVant.vue?vue&type=style&index=0&id=1a1dcefc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1dcefc",
  null
  
)

export default component.exports